import { useWeb3React } from '@web3-react/core';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { checkChainId } from '@/utils/web3Service';

import { onClaimBsc } from './helpers';

const useClaim = () => {
  const context = useWeb3React();
  const { chainId } = context;
  const provider = context.library?.provider;
  const account = context.account || '';
  const [loading, setLoading] = useState(false);

  const handleClaim = async (nonce: number, handleWhenClaimed: (nonce: number) => void) => {
    try {
      checkChainId(chainId);
      setLoading(true);
      const res: any = await onClaimBsc({
        provider,
        account,
        nonce,
        callback: (hash) => console.log(hash),
      });
      if (res?.blockHash) {
        toast.success('Claimed successfully!');
        handleWhenClaimed(nonce);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.log('claim err: ', error);
      toast.error(error?.message || 'An error occurred');
    }
  };

  return { handleClaim, loading };
};

export default useClaim;
